import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import security from "./security";
import auth from "./auth";

export default class CommonService {
  constructor($http, $localStorage, $state, $q, SecurityService, AuthService, $timeout, env) {
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$q = $q;
    this.$auth = AuthService;
    this.$security = SecurityService;
    this.galleryPictures = [];
    this.$timeout = $timeout;
    this.$env = env;

    this.jobblerData = null;
  }

  displayDetails(applicant, type, action) {
    var jobblerData = {};

    if (action === "open") {
      jobblerData = this.$security.getJobblerData(applicant, type);

      this.galleryPictures = jobblerData.pics;
      jobblerData.currentPicture = this.galleryPictures[0];
      jobblerData.currentIndex = 0;
      this.jobblerModal = true;
      this.jobblerData = jobblerData;
    } else {
      this.jobblerData = null;
      this.fullScreenGallery = false;
      this.jobblerModal = false;
    }
  }

  getJobblerData() {
    return this.jobblerData;
  }

  differenceInHours(start, end) {
    var totalMinutes = moment(end).diff(moment(start), "minutes");

    var ret = "";

    if (start === null || end === null) {
      ret = "--";
    } else {
      ret = Math.floor(totalMinutes / 60);
    }

    return ret;
  }

  differenceInMinutes(start, end) {
    var totalMinutes = moment(end).diff(moment(start), "minutes");

    var ret = "";

    if (start === null || end === null) {
      ret = "--";
    } else {
      ret = totalMinutes % 60;
    }

    return ret;
  }

  checkSystem() {
    return new Promise((resolve) => {
      let req = {
        method: "GET",
        url: `${this.$env.getAPIEndPoint()}public/jobble-types?format=json&max=1&displayOrder=asc&fields=id`,
        data: {},
        withCredentials: false,
      };

      this.$http(req)
        .then((data) => {

          console.log("response from system check");
          console.dir(data);

          if (data.status === 500) {
            return resolve({
              systemUp: false,
            });
          }

          if (data.status === 202) {
            return resolve({
              systemUp: true,
            });
          }

          if (data && data.data && data.data.length) {
            resolve({
              systemUp: true,
            });
          } else {
            resolve({
              systemUp: false,
            });
          }
        })
        .catch((err) => {
          console.error("API Error in from system check. Error:", err);
          resolve({
            systemUp: false,
          });
        });
    });
  }
}

CommonService.$inject = ["$http", "$localStorage", "$state", "$q", "security", "auth", "$timeout", "env"];



// WEBPACK FOOTER //
// ./client/app/services/common.js